import "core-js/modules/es.array.push.js";
import { createRouter, createWebHashHistory } from "vue-router"; // NProgress

import NProgress from "nprogress";
import "nprogress/nprogress.css";
import store from "@/store";
const state = store.state;
const routes = [{
  path: "/",
  redirect: "/login"
}, {
  path: "/login",
  name: "login",
  meta: {
    static: true,
    innerRoute: true
  },
  component: () => import("@/views/index/LoginView.vue")
}, {
  path: "/register",
  name: "register",
  meta: {
    static: true,
    innerRoute: false
  },
  component: () => import("@/views/index/RegisterView.vue")
}, // 添加NotFound路由
{
  path: "/:catchAll(.*)",
  meta: {
    static: true,
    innerRoute: true
  },
  component: () => import("@/views/index/NotFoundView.vue")
}];
const router = createRouter({
  history: createWebHashHistory(),
  routes
}); // 路由前

router.beforeEach((to, from, next) => {
  if (state.enterprise.uid || to.name == "login" || to.name == "register") {
    NProgress.start();
    next();
    NProgress.done();
  }
}); // 路由后

router.afterEach(to => {
  if (Object.keys(to.params).length == 0) {
    store.commit("setRouterHistory", to);
  }
}); // ----------------------------- 动态路由 -----------------------------
// 初始化动态路由

export const initRouter = routerList => {
  routerList.value.forEach(item => {
    const routerItem = ref({
      name: item.name,
      path: item.path,
      redirect: item.redirect ? {
        name: item.redirect
      } : undefined,
      component: item.component ? () => import("@/views" + item.component) : undefined,
      meta: {
        title: item.title,
        innerRouter: item.innerRouter,
        keepAlive: item.keepAlive
      },
      children: []
    }); // 构造子路由

    if (item.children) {
      routerItem.value.children = childrenRouter(item.children);
    }

    router.addRoute(routerItem.value);
  });
  const routerHistory = state.router.routerHistory;

  if (routerHistory.length > 0) {
    router.push({
      name: routerHistory[routerHistory.length - 1].name,
      replace: true
    });
  } else {
    if (state.auth.token != "") {
      router.push({
        name: "enterpriseDetail",
        replace: true
      });
      store.commit("setDefaultActive", "/enterprise");
    } else {
      router.push({
        name: "login",
        replace: true
      });
    }
  }
}; // 构造子路由

const childrenRouter = childrenList => {
  const childrenRouters = [];
  childrenList.forEach(item => {
    const routerItem = ref({
      name: item.name,
      path: item.path,
      redirect: item.redirect ? {
        name: item.redirect
      } : undefined,
      component: item.component ? () => import("@/views" + item.component) : undefined,
      meta: {
        title: item.title,
        innerRouter: item.innerRouter,
        keepAlive: item.keepAlive
      },
      children: []
    }); // 构造子路由

    if (item.children) {
      routerItem.value.children = childrenRouter(item.children);
    }

    childrenRouters.push(routerItem.value);
  });
  return childrenRouters;
};

export default router;